module.exports = __webpack_public_path__ + "static/media/unilance.ba449c7f.jpg";